import { Component, OnInit, Input } from "@angular/core";
import { Spell } from "../../../shared/models/spell";

@Component({
  selector: "app-spell-detail",
  templateUrl: "./spell-detail.component.html",
  styleUrls: ["./spell-detail.component.scss"]
})
export class SpellDetailComponent implements OnInit {

  @Input()
  spell: Spell;

  @Input()
  i: number;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/spell-dashboard/components/spell-detail/spell-detail.component.ts